var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.512529 0.513805C0.184381 0.841587 0 1.28637 0 1.75018C0 2.214 0.184381 2.65879 0.512529 2.98657L9.58225 12.0534C10.2645 12.7348 11.3698 12.7348 12.0521 12.0534L21.1218 2.98366C21.8047 2.30164 21.8054 1.19516 21.1233 0.512306C20.4413 -0.170547 19.3348 -0.171204 18.6519 0.510849L10.8172 8.3486L2.98238 0.513805C2.3001 -0.167629 1.19481 -0.167625 0.512529 0.513805Z",
    fill: "#050B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.9bddbc255290dd28b06148a2b60b1ac5.svg";
export { ForwardRef as ReactComponent };